import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import { FaBars } from 'react-icons/fa'

export default class Navbar extends Component {
    state = {
        isOpen: false,
        isMounted: false
    };
    handleToggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    componentDidMount() {
        this.setState(prevState => ({ isMounted: !prevState.isMounted }))
    }

    handleClick = () => {
        this.handleToggle
        this.scrollToMyRef
    }

    render() {
        return (
            <nav className="navbar notdesktop slideDown">
                <div className="navbar-container">
                <div className="logo-container">
                    <Link to="/">
                        {/* classname z propu > meneni loga podle velikosti obrazovky */}
                        <img className="logo" src={this.props.logo} data-value="mobileLogo" alt="mobileLogo"></img>
                    </Link>
                </div>
                <button type="button" className="nav-btn">
                       <FaBars onClick={this.handleToggle} className="nav-icon" /> 
                    </button>
                    
                <ul className={this.state.isOpen? "nav-links show-nav":"nav-links"}>
                    <li className="menu-item">
                        <a onClick={this.handleToggle} className="scroll" href="#services" >služby</a>
                    </li>
                    <li className="menu-item">
                        <a className="scro" href="#portfolio" onClick={this.handleToggle}>reference</a>
                    </li>
                    <li className="menu-item">
                        <a className="scroll" href="#about" onClick={this.handleToggle}>o nás</a>
                    </li>
                    <a className="scro menu-contact-btn" id="hello" onClick={this.handleClick}><li className="menu-item">
                        kontakt
                    </li></a>
                </ul>
                        
                
                </div>
            </nav>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Navbar.js